function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4479 0.67233L10.93 0.666504C6.97779 0.666504 4.4237 3.37116 4.4237 7.55734V10.7345H0.886646C0.581003 10.7345 0.333496 10.9902 0.333496 11.3057V15.909C0.333496 16.2245 0.581285 16.48 0.886646 16.48H4.4237V28.0956C4.4237 28.411 4.67121 28.6665 4.97685 28.6665H9.5917C9.89735 28.6665 10.1449 28.4107 10.1449 28.0956V16.48H14.2805C14.5861 16.48 14.8336 16.2245 14.8336 15.909L14.8353 11.3057C14.8353 11.1542 14.7769 11.0092 14.6733 10.902C14.5698 10.7948 14.4287 10.7345 14.2819 10.7345H10.1449V8.04118C10.1449 6.74667 10.4437 6.08951 12.0775 6.08951L14.4473 6.08864C14.7527 6.08864 15.0002 5.83288 15.0002 5.5177V1.24326C15.0002 0.928377 14.7529 0.672912 14.4479 0.67233Z",
  fill: "#09BAD3"
});

var SvgFacebookIc = function SvgFacebookIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 29,
    viewBox: "0 0 15 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook_ic.a43ec44f.svg";
export { ForwardRef as ReactComponent };